import { Save } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Format from './../Format';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import Message from '../Message';
import datas from "../../Assets/data.json";
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
//import axios from 'axios';
import { FormSection, FormActions, useAlert, Spin, Select, Button } from '../ui';


export interface ConfirmationDialogRawProps {
    classes: Record<'paper', string>;
    id: string;
    keepMounted: boolean;
    value: string;
    open: boolean;
    onClose: (value?: string) => void;
}

const FormTransfert = (props: { reccord?: any, handleFunction: any }) => {
    // USER TOKEN
    const authHeader = useAuthHeader()

    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert();

    const { register, handleSubmit, setValue, reset } = useForm()
    const [fichier, setFicher] = useState<File>()
    const [isOk, setIsOk] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const [caisse, setCaisse] = useState('');
    const [caisses, setCaisses] = useState([])

    const handleChange = (value: string) => {
        setCaisse(value);
    };
    const loadCaisse = async () => {
        const codeAbonne = user.CodeAbonne
        setLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Operationnels + Crypter.encrypt(codeAbonne),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response) => {
                setLoading(false)
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    let dte: any = []
                    res.Result.map((e: any) => {
                        if (e.CodeU != user.CodeU  && e.CodeFiliale == user.CodeFiliale && e.CodeS == user.CodeS) {
                            dte.push(e)
                        }
                    })
                    setCaisses(dte)
                } else {
                    alert.warning(res.Message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            });

    }
    const onSubmit = async () => {
        setLoading(true)

        let data = JSON.stringify({
            "CodeT": props.reccord.CodeT,
            "CodeU": user.CodeU,
            "CodeOperateur": caisse.split('|')[0],
            "CodeAbonne": user.CodeAbonne,
            "CodeS": user.CodeS,
            "CodeFiliale": user.CodeFiliale
        });

        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Transfert,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
            },
            data: Crypter.encrypt(data)
        };

        axios.request(config)
            .then((response) => {
                setLoading(false)
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    alert.success(res.Message)
                    props.handleFunction()
                }

                else {
                    alert.warning(res.Message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            });

    }

    return (
        <>
            <Spin spinning={loading}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormSection title="Transfert de ticket" subtitle="Sélectionnez l'opérateur destinataire">
                        <div onClick={() => { setCaisses([]); loadCaisse() }}>
                            <Select
                                label="Opérateur récepteur"
                                value={caisse}
                                onChange={handleChange}
                                options={caisses.map((e: any) => ({
                                    value: e.CodeU + "|" + e.NumBox,
                                    label: e.CodeU + ' - ' + e.Name + " " + e.Prenom + ' (N° Box : ' + e.NumBox + ', Service : ' + e.CodeS + ')'
                                }))}
                            />
                        </div>
                    </FormSection>

                    <FormActions>
                        <Button variant='secondary' type='submit' startIcon={<Save size={16} />}>Transférer</Button>
                    </FormActions>
                </form>
            </Spin>
        </>
    );
};

export default FormTransfert;
